/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LearningOutcomeTemplateDTO,
    LearningOutcomeTemplateDTOFromJSON,
    LearningOutcomeTemplateDTOFromJSONTyped,
    LearningOutcomeTemplateDTOToJSON,
} from './LearningOutcomeTemplateDTO';

/**
 * 
 * @export
 * @interface ScienceBranchUpdateDTO
 */
export interface ScienceBranchUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof ScienceBranchUpdateDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ScienceBranchUpdateDTO
     */
    fundamentalDomainId?: string;
    /**
     * 
     * @type {Array<LearningOutcomeTemplateDTO>}
     * @memberof ScienceBranchUpdateDTO
     */
    learningOutcomeTemplates?: Array<LearningOutcomeTemplateDTO> | null;
}

export function ScienceBranchUpdateDTOFromJSON(json: any): ScienceBranchUpdateDTO {
    return ScienceBranchUpdateDTOFromJSONTyped(json, false);
}

export function ScienceBranchUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScienceBranchUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'fundamentalDomainId': !exists(json, 'fundamentalDomainId') ? undefined : json['fundamentalDomainId'],
        'learningOutcomeTemplates': !exists(json, 'learningOutcomeTemplates') ? undefined : (json['learningOutcomeTemplates'] === null ? null : (json['learningOutcomeTemplates'] as Array<any>).map(LearningOutcomeTemplateDTOFromJSON)),
    };
}

export function ScienceBranchUpdateDTOToJSON(value?: ScienceBranchUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'fundamentalDomainId': value.fundamentalDomainId,
        'learningOutcomeTemplates': value.learningOutcomeTemplates === undefined ? undefined : (value.learningOutcomeTemplates === null ? null : (value.learningOutcomeTemplates as Array<any>).map(LearningOutcomeTemplateDTOToJSON)),
    };
}

